import { tokens } from "gatsby-env-variables"

import { getItem, setItem } from "@housing/utils"
import "@housing/utils/bootstrap"
import appTrackers from "@housing/utils/tracking/appTrackers"

import configure from "@mobi/ds/configure"
import analytics from "@mobi/libraries/analytics"

import "styles/index.scss"

import { isBankVariant } from "./src/utils"

const variant = isBankVariant("personnalite") ? "personnalite" : "varejo"

configure({
  variant,
  originFonts: "extern",
  fonts: {
    ItauDisplay: [900],
    ItauText: [400, 700]
  },
  setStyleVariablesInHTML: false
})

if (!getItem("appGeoloc")) {
  navigator.geolocation.getCurrentPosition((position) => {
    setItem("appGeoloc", {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    })
  })
}

if (!window.analyticsData) {
  window.analyticsData = {}
}

analytics.setup({
  segmentId: tokens.SEGMENT,
  GTMId: tokens.GTMId,
  trackings: appTrackers,
  makeTagular: tokens.MAKE,
  isSDKTrackings: true
})
